import React, { useState, useEffect } from 'react';

const BLACK_POSTER = "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";

export function VideoViewModal({
  src,
  type = "video/mp4",
  caption,
  credit,
  autoPlay = false,
  expandLabel = "⤢ Expand video",
  poster,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => { if (e.key === "Escape") closeModal(); };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [isOpen]);

  return (
    <>
      <div className="videoViewContainer">
        <video controls className="videoViewInline" poster={poster || BLACK_POSTER} autoPlay={autoPlay} muted={autoPlay} loop={autoPlay}>
          <source src={src} type={type} />
          Your browser does not support the video element. Kindly update it to latest version.
        </video>
        <button className="videoViewExpandBtn" onClick={openModal}>
          {expandLabel}
        </button>
        {caption && <div className="videoViewCaption">{caption}</div>}
        {credit && <div className="videoViewCredit">{credit}</div>}
      </div>
      {isOpen && (
        <div className="videoModalBackdrop" onClick={closeModal}>
          <div className="videoModalContent" onClick={(e) => e.stopPropagation()}>
            <button className="videoModalClose" onClick={closeModal}>✕ Close</button>
            <video controls autoPlay className="videoModalPlayer" poster={poster || BLACK_POSTER}>
              <source src={src} type={type} />
              Your browser does not support the video element.
            </video>
          </div>
        </div>
      )}
    </>
  );
}
